import underConst from '../../assets/const.png'
const Register = () => {
  return (
    <div>
        <img 
            src={underConst} 
            alt="" 
            style={{ 
                width: '80%', 
                display: 'block',
                margin: '2rem auto ', 
            }}
        />
    </div>
  )
}

export default Register;